import React from 'react'
import { PageContent, Video } from 'components/library'

class Aspect01 extends React.Component {
  render() {
    return (
      <div className="Chapter02-Aspect01">
        <PageContent nospacing>
          <Video vimeoId={330732944}/>
        </PageContent>
      </div>
    )
  }
}

export default Aspect01



// WEBPACK FOOTER //
// ./src/content/chapters/02/01/Aspect01.js